import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { VclDetailInsModComponent } from './vcl-detail-ins-mod/vcl-detail-ins-mod.component';

@Component({
  selector: 'app-vcl-institution-module',
  templateUrl: './vcl-institution-module.component.html',
  styleUrls: ['./vcl-institution-module.component.scss']
})
export class VclInstitutionModuleComponent extends TableComponent{
constructor(
      private elRef:ElementRef,
      public cdRef: ChangeDetectorRef,
      public helper: HelperModule,
      public dialog: MatDialog,
      private apiService: ApiServiceModule,
      private sharedService: SharedService,
      public sanitizer: DomSanitizer) {
        super(sanitizer);
    }
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() platformInfos: { [x:string]: any } = new Map();
  @Input() filterData:any = [];
  @Input() manageKey:string = 'structure';
  metaData:{[x: string]: any} = new Map();
  manageKeyValue:any = {
    'structure': {element: 'Structure', parent: 'Institution'},
    'department': {element: 'Depatment', parent: 'Structure'},
    'vca_module': {element: 'Module', parent: 'Department'}
  }
  mergeData:{[x: string]: any}[]= [];

  ngOnInit() {
    this.loadRessourceData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterData'] && !changes['filterData'].firstChange) {
      this.loadRessourceData();
    }
  }
  loadRessourceData(){
    this.inProgress.emit(true);
    if(this.filterData && Object.keys(this.filterData).length > 0){
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/web/vcl-institution-module/load_vcl', this.filterData, this.userInfos['access_token']).subscribe((response:any)=>{
        this.dataSource = response.data;
        this.metaData = response.metadata;
        this.showedRows = this.dataSource;
        this.mergeData = this.dataSource;
        this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;

        this.inProgress.emit(false);
      });
    }
  }
  setUpdatedRow(data:any){

  }
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  setWaiting(data:any){

  }
  depInsModAdd(){
    const dialogRef = this.dialog.open(VclDetailInsModComponent, {
      width: '90%',
      position: {top: '30px' },
      data: {action: 'add_new', manage_key: this.manageKey, manage_key_value: this.manageKeyValue, row_infos: {}, metadata: this.metaData, merge_data: {}, user_infos: this.userInfos, platform_infos: this.platformInfos}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
      if(response && response.action == 'delete_promo'){
        this.dataSource = this.dataSource.filter((el:any)=> !response.delete_rows.includes(el.id));
        this.showedRows = this.showedRows.filter((el:any)=> !response.delete_rows.includes(el.id));
      }
    });
  }
  depInsModOption(rowInfos:{ [x:string]: any },){
    /* let duplicateRows = this.classifyData.filter((row: any)=> row.id_content_duplicate == rowInfos['id_content'] && row.source == 'content')
    const dialogRef = this.dialog.open(ClassifySettingComponent, {
      width: '70%',
      position: {top: '30px' },
      data: {is_multiple: false, selected_rows: [rowInfos], duplicate_rows: duplicateRows, user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: this.projectInfos}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
      
    }); */
  }
  depInsModSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      /* const dialogRef = this.dialog.open(ClassifySettingComponent, {
        width: '70%',
        position: {top: '30px' },
        data: {is_multiple: true, selected_rows: selectedRows, duplicate_rows: [], user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: this.projectInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
        
      }); */
    }else this.helper.showToast('Select contents first...');
  }
  selectAllOption(element: any){
    this.selectAll(element);
    this.cdRef.detectChanges();
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }

}
